<div *ngIf="(showCommonItems$ | async)">
    <emm-common-item
        [selectedItem]="(item$ | async)"
        [selectedFeatureScope]="featureScope"
        [selectedLocation]="menuParams?.menuKey?.location"
        [selectedSubmenu]="selectedSubmenu"
        [selectedConsumer]="menuParams?.menuKey?.consumer"
    ></emm-common-item>
</div>
<div *ngIf="!(showCommonItems$ | async)">
    <header>
        <emm-legend-items [items]="legendItems"></emm-legend-items>
        <mat-form-field *ngIf="featureScope === 'Global'">
            <mat-select
                [attr.data-testid]="'add_new_attribute_select'"
                [disabled]="isReadOnly$ | async"
                placeholder="Add New Attribute"
                (selectionChange)="handleNewAttributeSelection($event)"
            >
                <mat-option
                    *ngFor="let attr of item.unassigned; let i = index"
                    [attr.data-testid]="attr.name + '_option'"
                    [value]="i"
                >
                    {{ attr.name }}
                </mat-option>
            </mat-select>
        </mat-form-field>
    </header>

    <mat-accordion [multi]="true">
        <div *ngFor="let attributeGroup of attributeGroups">
            <mat-expansion-panel
                [style.display]="hasValue(attributeGroup.id) ? 'block' : 'none'"
                [ngClass]="{ 'attribute-group-open': attributeGroup == selectedStatus }"
                [attr.id]="attributeGroup.id"
                (closed)="closePanel(attributeGroup)"
                (opened)="openPanel(attributeGroup)"
                [expanded]="attributeAdded ? attributeGroup.id == 'DYNAMIC' :
            previousAttributeGroups ? isPreviousPanel(attributeGroup) : false"
                #attributeGroup
            >
                <mat-expansion-panel-header>
                    <mat-panel-title [attr.data-testid]="attributeGroup.name">
                        {{ attributeGroup.name }}
                    </mat-panel-title>
                </mat-expansion-panel-header>
                <emm-dynamic-menu-form
                    [attributes]="attributesByGroup.get(attributeGroup.id) | async"
                    [attributeGroupId]="attributeGroup.id"
                    [existingUpdates]="existingUpdates"
                    [itemTag]="item.tag" [itemTagPath]="itemNode?.data?.id"
                    [form]="form"
                    [isReadOnly]="featureScope === 'Viewer' ? true : isReadOnly$ | async"
                    [selectedSubmenu]="selectedSubmenu"
                    [selectedFeatureScope]="featureScope"
                    [selectedLocation]="menuParams.menuKey.location"
                    [effectiveDate]="effectiveDate"
                    [nodeId]="nodeId"
                    [language]="language"
                    [isCascade]="false"
                    (removeLocalAttribute)="handleRemoveLocalAttribute($event)"
                >
                </emm-dynamic-menu-form>
            </mat-expansion-panel>
        </div>
    </mat-accordion>
    <br>
    <div class="fixed-row-for-buttons">
        <emm-attributes-footer
            *ngIf="(formsBuilt | async) && ((selectedFeatureScope$ | async) === 'Global') && (newUpdateFlow$ | async)"
            [disableCancel]="!hasChanges() || (disabled$ | async)"
            [disableCascade]="isSubMenu || !hasChanges() || (disabled$ | async) || hasInvalidFormfield()"
            [disableUpdate]="!hasChanges() || (disabled$ | async) || hasInvalidFormfield()"
            [dialogService]="dialogService"
            [locationSet]="locationSet"
            (cancel)="cancelAllDirtyAttributeGroups()"
            (update)="updateItem()"
            (updateItemCascade)="updateItemCascade()"
            class="form-width"
        ></emm-attributes-footer>
        <emm-attributes-footer
            *ngIf="(formsBuilt | async) && ((selectedFeatureScope$ | async) === 'Global') && !(newUpdateFlow$ | async)"
            [disableCancel]="!hasChanges() || (disabled$ | async)"
            [disableCascade]="isSubMenu || !hasChanges() || (disabled$ | async) || hasInvalidFormfield()"
            [disableUpdate]="!hasChanges() || (disabled$ | async) || hasInvalidFormfield()"
            [dialogService]="dialogService"
            [locationSet]="locationSet"
            (cancel)="cancelAllDirtyAttributeGroups()"
            (update)="submit()"
            (updateItemCascade)="updateItemCascade()"
            (forceOverrideInheritance)="forceOverrideInheritance($event)"
            class="form-width"
        ></emm-attributes-footer>
    </div>

</div>
